module.exports = {
      id: "normal-usage",
      viewBox: "0 0 544 152",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#normal-usage",
      toString: function () {
        return this.url;
      }
    }